// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__15ixQ","actions":"GroupTable_actions__inxCR","deleteModalFooter":"GroupTable_deleteModalFooter__2ofR3"};